module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-ee7ecc736fa1d38e5902da035f7bd8b7.png";